import React from "react";

import { Location } from "../types";

const LocationList: React.FC<{ locations: Location[] }> = ({ locations }) => {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {locations.map((location) => {
        // The same GraphQL query returns residents, so the faces come free.
        const residents = location.residents ?? [];
        const preview = residents.slice(0, 5);

        return (
          <article
            key={location.id}
            className="flex flex-col rounded-xl border border-white/10 bg-space-800 p-4 transition hover:-translate-y-0.5 hover:border-portal-400/50 hover:shadow-xl hover:shadow-black/40"
          >
            <h3 className="font-semibold text-white">{location.name}</h3>
            <p className="mt-2 text-sm text-slate-400">
              {location.type || "Unknown type"}
            </p>
            <p className="text-sm text-slate-400">
              {location.dimension || "Unknown dimension"}
            </p>

            <div className="mt-4 flex items-center gap-3">
              {preview.length > 0 ? (
                <>
                  <div className="flex -space-x-2">
                    {preview.map((resident) => (
                      <img
                        key={resident.id}
                        src={resident.image}
                        alt=""
                        loading="lazy"
                        className="h-8 w-8 rounded-full border-2 border-space-800 object-cover"
                      />
                    ))}
                  </div>
                  <span className="text-xs text-slate-400">
                    {residents.length} resident
                    {residents.length === 1 ? "" : "s"}
                  </span>
                </>
              ) : (
                <span className="text-xs text-slate-500">No known residents</span>
              )}
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default LocationList;
